import { getApiBaseUrl } from "../config/env";
import { API_ENDPOINTS } from "../constants/apiEndpoints";

export const SAML_CALLBACK_PATH = "/sso/callback";

function getSamlCallbackUrl(): string {
	const configured = import.meta.env.VITE_SAML_CALLBACK_URL?.trim();
	if (configured) return configured;
	return `${window.location.origin}${SAML_CALLBACK_PATH}`;
}

export function getSamlLoginUrl(): string {
	const url = new URL(`${getApiBaseUrl()}${API_ENDPOINTS.auth.samlLogin}`);
	url.searchParams.set("returnUrl", getSamlCallbackUrl());
	return url.toString();
}

export function redirectToSamlLogin(): void {
	window.location.assign(getSamlLoginUrl());
}
